export default __webpack_public_path__ + "static/media/thumbs-up.d0a01148.png";